import {parse} from "mathjs";
export const answerText=value=>String(typeof value==="object"?value?.raw??"":value??"").trim();
export function checkQuadraticEquation(value,expected){
 try{
  const text=answerText(value).replace(/−/g,"-").replace(/²/g,"^2").replace(/\^\{(\d+)\}/g,"^$1"),sides=text.split("=");
  if(text.length>600||sides.length!==2||sides.some(s=>!s.trim()))return {correct:false};
  const tree=parse(`(${sides[0]})-(${sides[1]})`.replace(/x\(/g,"x*("));
  function degree(node){
   if(node.isConstantNode&&Number.isFinite(Number(node.value)))return 0;
   if(node.isSymbolNode&&node.name==="x")return 1;
   if(node.isParenthesisNode)return degree(node.content);
   if(!node.isOperatorNode)return NaN;
   const d=node.args.map(degree);if(d.some(x=>!Number.isFinite(x)))return NaN;
   if(["+","-"].includes(node.op))return Math.max(...d);
   if(node.op==="*")return d.reduce((a,b)=>a+b,0);
   if(node.op==="/"&&d[1]===0)return d[0];
   if(node.op==="^"&&node.args[1].isConstantNode&&[0,1,2].includes(Number(node.args[1].value)))return d[0]*Number(node.args[1].value);
   return NaN;
  }
  if(!(degree(tree)<=2))return {correct:false};
  const f=x=>Number(tree.evaluate({x})),C=f(0),A=(f(2)-2*f(1)+C)/2,B=f(1)-C-A;
  const actual=[A,B,C],scale=A/expected[0];
  const correct=Number.isFinite(scale)&&Math.abs(scale)>1e-10&&actual.every((v,i)=>Math.abs(v-scale*expected[i])<1e-8*Math.max(1,Math.abs(v)));
  const messages=[];
  if(correct&&sides[1].trim()!=="0")messages.push("Równanie jest równoważne i zostało zaakceptowane. Dla czytelności możesz przenieść wyrazy na jedną stronę i przyrównać do zera.");
  if(correct&&actual.every(Number.isInteger)){
   const gcd=(a,b)=>b?gcd(b,a%b):Math.abs(a),factor=actual.reduce(gcd,0);
   if(factor>1)messages.push(`Współczynniki są poprawne. Możesz skrócić równanie, dzieląc je przez ${factor}.`);
  }
  return {correct,messages};
 }catch{return {correct:false};}
}
